export enum FirebaseTestConfig {
  PROJECT_ID = 'control-tower-test',
  API_KEY = 'control-tower-test',
}
